import React, { useEffect } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import CourseWareViewer from "../../../components/CourseComponents/CourseWareViewer";
import { getCourseWareInfo } from "service/course";
import ResourceEmpty from "./components/ResourceEmpty";
import { toNumber } from "service/service";
import useQuery from "utils/useQuery";
import { currentResourceAtom, resourceModalAtom } from "../Store";
import { useSetAtom, useAtom } from "jotai";

export default function Resource() {
    const { id } = useQuery<{ id: string }>(); // 默认打开课件id

    const setResourceModalState = useSetAtom(resourceModalAtom);
    const [currentResource, setCurrentResource] = useAtom(currentResourceAtom);

    useEffect(() => {
        if (!id) return;
        getCourseWare();
    }, [id]);

    async function getCourseWare() {
        const courseWare = await getCourseWareInfo(toNumber(id));
        setCurrentResource(courseWare);
    }

    return (
        <div className={classNames(style.root, { [style.empty]: true })}>
            {currentResource && <CourseWareViewer data={currentResource} />}
            {!currentResource && (
                <ResourceEmpty
                    onClick={() => setResourceModalState("resource")}
                />
            )}
        </div>
    );
}
